package org.bsvac.bsvac_kmp.data.models

enum class TourModel(val displayString: String) {
    TOUR_1("TOUR 1"),
    TOUR_2("TOUR 2"),
    TOUR_3("TOUR 3"),
    STANDBY("STANDBY");

    companion object {
        fun validEntries(selectedAgency: AgencyModel?): List<TourModel> {
            return when (selectedAgency) {
                null -> emptyList()
                else -> TourModel.entries
            }
        }
    }
}